module.exports = __webpack_public_path__ + "img/strikethrough.d9a984cf.svg";